import type { PropsWithChildren } from 'react'
import { createContext, useCallback, useState } from 'react'

import type { BreadcrumbTrail } from '../components/Breadcrumbs'

export { PageInfoProvider, PageInfoContext }

const PageInfoContext = createContext<{
  breadcrumbs: BreadcrumbTrail
  setBreadcrumbs: (breadcrumbs: BreadcrumbTrail) => void
} | null>(null)

const PageInfoProvider = ({ children }: PropsWithChildren) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbTrail>([])

  const setBreadcrumbsCallback = useCallback(
    (newBreadcrumbs: BreadcrumbTrail) => {
      if (
        newBreadcrumbs.length === breadcrumbs.length &&
        JSON.stringify(newBreadcrumbs) === JSON.stringify(breadcrumbs)
      ) {
        return
      }

      setBreadcrumbs(newBreadcrumbs)
    },
    [setBreadcrumbs, breadcrumbs],
  )

  return (
    <PageInfoContext.Provider
      value={{
        breadcrumbs,
        setBreadcrumbs: setBreadcrumbsCallback,
      }}
    >
      {children}
    </PageInfoContext.Provider>
  )
}
